import { useState, useEffect } from 'react';

// Endpoints
import { TRANSLATE } from '@/lib/routes/apiEndpoints';

// Utils
import { get } from '@/utils/client';

const useAwsTranslate = (value) => {
    const getInitialData = (initialValue) => {
        return {
            original: initialValue,
            translated: null,
            isSameLanguage: false,
            isLoading: false,
            isDisplayed: false,
            errors: null
        };
    };

    const [awsTranslation, setAwsTranslation] = useState(getInitialData(value));

    useEffect(() => {
        setAwsTranslation(getInitialData(value));
    }, [value]);

    const awsToggleTranslation = async () => {
        if (awsTranslation?.isDisplayed) {
            setAwsTranslation({ ...awsTranslation, isDisplayed: false });
        } else {
            if (awsTranslation?.translated !== null) {
                setAwsTranslation({
                    ...awsTranslation,
                    isDisplayed: !awsTranslation?.isSameLanguage
                });
            } else {
                setAwsTranslation({ ...awsTranslation, isLoading: true });
                try {
                    const data = await get(
                        TRANSLATE,
                        {
                            text: encodeURIComponent(value)
                        },
                        {},
                        { encode: false }
                    );
                    setAwsTranslation({
                        ...awsTranslation,
                        translated: data?.data?.text,
                        isSameLanguage: data?.data?.same_language,
                        isLoading: false,
                        isDisplayed: !data?.data?.same_language
                    });
                } catch (e) {
                    setAwsTranslation({
                        ...awsTranslation,
                        isLoading: false,
                        errors: e
                    });
                }
            }
        }
    };

    return {
        awsTranslation,
        awsToggleTranslation
    };
};

export default useAwsTranslate;
